import { chargerStatusService } from "../../helpers/chargerStatusService";

export const state = {
  getAllBusyCharger: [],
  getAllUnderMaintenanceCharger: [],
  underMaintenanceChargerCount: "",
  busyChargerCount: "",
  getAllAvailableCharger: [],
  availableChargerCount: "",
  getAllUnavailableCharger: [],
  unavailableChargerCount: "",
  pagination: {},
  loading: true,
};

export const mutations = {
  getAllBusyCharger(state, payload) {
    state.getAllBusyCharger = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.busyChargerCount = payload.result.total;
  },
  getAllUnderMaintenanceCharger(state, payload) {
    state.getAllUnderMaintenanceCharger = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.underMaintenanceChargerCount = payload.result.total;
  },
  getAllAvailableCharger(state, payload) {
    state.getAllAvailableCharger = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.availableChargerCount = payload.result.total;
  },
  getAllUnavailableCharger(state, payload) {
    state.getAllUnavailableCharger = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.unavailableChargerCount = payload.result.total;
  },
  getBusyChargerListRequest(state) {
    state.loading = true;
  },
  getAvailableChargerListRequest(state) {
    state.loading = true;
  },
  getUnavailableChargerListRequest(state) {
    state.loading = true;
  },
  getBusyCharger(state, payload) {
    state.user = payload.result;
  },
  getAvailableCharger(state, payload) {
    state.user = payload.result;
  },
  getUnavailableCharger(state, payload) {
    state.user = payload.result;
  },
  getBusyChargerListFailure(state) {
    state.loading = false;
  },
  getAvailableChargerListFailure(state) {
    state.loading = false;
  },
  getUnavailableChargerListFailure(state) {
    state.loading = false;
  },
};

export const actions = {
  async getBusyCharger({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getBusyChargerListRequest");
    await chargerStatusService.getBusyCharger(data).then(
      (response) => {
        commit("getAllBusyCharger", response.data);
      },
      (error) => {
        commit("getBusyChargerListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async getUnderMaintenanceCharger({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getBusyChargerListRequest");
    await chargerStatusService.getUnderMaintenanceCharger(data).then(
      (response) => {
        commit("getAllUnderMaintenanceCharger", response.data);
      },
      (error) => {
        commit("getBusyChargerListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async getAvailableCharger({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getAvailableChargerListRequest");
    await chargerStatusService.getAvailableCharger(data).then(
      (response) => {
        commit("getAllAvailableCharger", response.data);
      },
      (error) => {
        commit("getBusyChargerListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async getUnavailableCharger({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getUnavailableChargerListRequest");
    await chargerStatusService.getUnavailableCharger(data).then(
      (response) => {
        commit("getAllUnavailableCharger", response.data);
      },
      (error) => {
        commit("getUnavailableChargerListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
};
export const getters = {
  loading: (state) => state.loading,
  getAllBusyCharger: (state) => state.getAllBusyCharger,
  getAllUnderMaintenanceCharger: (state) => state.getAllUnderMaintenanceCharger,
  underMaintenanceChargerCount: (state) => state.underMaintenanceChargerCount,
  busyChargerCount: (state) => state.busyChargerCount,
  upComingBookingData: (state) => state.getBusyCharger,
  getAllAvailableCharger: (state) => state.getAllAvailableCharger,
  availableChargerCount: (state) => state.availableChargerCount,
  getAllUnavailableCharger: (state) => state.getAllUnavailableCharger,
  unavailableChargerCount: (state) => state.unavailableChargerCount,
  pagination: (state) => state.pagination,
};
